<template>
    <div>
      <h1 class="subheading text-center mt-8" style="color: #f28a3e">HO - Operations</h1>
      <!-- Disha Section  -->
      <div id="disha" class="team">
      <v-container>
        <v-row>
          <v-col
            v-for="(item, index) in dishaItems"
            :key="index"
            cols="12"
            sm="6"
            md="4"
            lg="2"
          >
            <a
              :href="item.href"
              style="text-decoration: none; display: block; width: 100%"
            >
              <div class="tile-container tileCtr">
                <div
                  class="icon-container iconCtr"
                  :style="{ backgroundColor: item.bgColor }"
                >
                  <v-icon :style="{ color: item.iconColor, fontSize: '2.5rem' }">
                    {{ item.iconName }}
                  </v-icon>
                </div>
                <div
                  class="title-container titleCtr"
                  :style="{ color: item.iconColor }"
                >
                  {{ item.title }}
                </div>
              </div>
            </a>
          </v-col>
        </v-row>
      </v-container>
    </div>
      {{ authKey }}
    </div>
  </template>
  
  <script>
  export default {
    data() {
      return {
        activeProject: "",
        authKey: localStorage.getItem("auth-key"),
       
        dishaItems: [
      {
          href: "https://spencers-visit.attabot.in/",
          title: "Dashboard",
          iconName: "dashboard",
          bgColor: "#FFEFD5",
          iconColor: "#F44336"
        },
        
        {
          href: "https://spencers-visit.attabot.in/checklist",
          title: "Checklist",
          iconName: "check",
          bgColor: "#F3E5F5",
          iconColor: "#8E24AA"
        },
        {
          href: "https://spencers-visit.attabot.in/form",
          title: "Dynamic Form",
          iconName: "mdi-lumx",
          bgColor: "#F1F8E9",
          iconColor: "#8BC34A"
        },
        {
          href: "https://spencers-visit.attabot.in/report",
          title: "Report",
          iconName: "report",
          bgColor: "#E0F7FA",
          iconColor: "#00796B"
        },
        {
          href: "https://spencers-visit.attabot.in/petty-cash",
          title: "Petty Cash",
          iconName: "mdi-cash-multiple",
          bgColor: "#F1F8E9",
          iconColor: "#43A047"
        },
        {
          href: "https://spencers-visit.attabot.in/transaction-complain",
          title: "Transaction Complain",
          iconName: "mdi-cash-100",
          bgColor: "#E3F2FD",
          iconColor: "#1E88E5"
        },
        {
          href: "https://spencers-visit.attabot.in/notes",
          title: "Notes",
          iconName: "list",
          bgColor: "#E0F7FA",
          iconColor: "#00796B"
        },
        {
          href: "https://spencers-visit.attabot.in/photo-sharing-event",
          title: "Events",
          iconName: "folder_shared",
          bgColor: "#EFEBE9",
          iconColor: "#6D4C41"
        },
        
       
        {
          href: "https://spencers-visit.attabot.in/pop",
          title: "POP",
          iconName: "print",
          bgColor: "#FFF8E1",
          iconColor: "#F9A825"
        },
        {
          href: "https://spencers-visit.attabot.in/barcodeScan",
          title: "OSA",
          iconName: "mdi-jira",
          bgColor: "#F3E5F5",
          iconColor: "#8E24AA",
        },
        {
          href: "https://spencers-visit.attabot.in/comments",
          title: "Comments",
          iconName: "chat",
          bgColor: "#FFF3E0",
          iconColor: "#FF7043"
        },
       
        {
          href: "https://spencers-visit.attabot.in/user",
          title: "Users",
          iconName: "person",
          bgColor: "#E8F5E9",
          iconColor: "#388E3C"
        },
        {
          href: "https://spencers-visit.attabot.in/stores",
          title: "Stores",
          iconName: "home",
          bgColor: "#FFF8E1",
          iconColor: "#FFA000"
        },
        {
          href: "https://spencers-visit.attabot.in/tags",
          title: "Tags",
          iconName: "mdi-tag",
          bgColor: "#FCE4EC",
          iconColor: "#D81B60"
        },
        {
          href: "https://spencers-visit.attabot.in/document-share",
          title: "Store Document",
          iconName: "folder",
           bgColor: "#E0F7FA",
          iconColor: "#00796B"
        },
        {
          href: "https://spencers-visit.attabot.in/schedule",
          title: "Schedule",
          iconName: "cloud",
          bgColor: "#E0F7FA",
          iconColor: "#4DD0E1"
        },
        {
          href: "https://spencers-visit.attabot.in/vendorFeedbackReport",
          title: "NPS Vendor",
          iconName: "mdi-asterisk",
          bgColor: "#E3F2FD",
          iconColor: "#1976D2"
        },
        {
          href: "https://spencers-visit.attabot.in/nps",
          title: "Voice Of Customer",
          iconName: "person",
          bgColor: "#FCE4EC",
          iconColor: "#D81B60"
        },

        
        {
          href: "https://spencers-visit.attabot.in/contactUs",
          title: "Log Complain",
          iconName: "computer",
          bgColor: "#ECEFF1",
          iconColor: "#546E7A"
        }
      ]
      };
    },
    watch: {
      $route(newValue) {
        this.activeProject = newValue.params;
      }
    }
  };
  </script>
  <style>
  html {
    height: 200%;
    scroll-behavior: smooth;
  }
  
  .tiles {
    background: #ffb6c1;
    transition: 0.3s ease-out 100ms;
    width: 150px;
    height: 150px;
  }
  
  .tiles:hover {
    cursor: pointer;
    background: #fae4d5 !important;
  }
  
  .title-container {
    display: flex;
    justify-content: center;
    width: 100%;
  }
  
  .title-text {
    color: #f28a3e;
    font-size: 0.9rem !important;
    font-weight: bold;
    text-align: center;
  }
  
  .tileCtr {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    box-shadow: rgba(0, 0, 0, 0.24) 0px 3px 8px;
    border-radius: 8px;
    padding: 20px;
    text-align: center;
    transition: background 0.2s ease, transform 0.2s ease, box-shadow 0.2s ease;
  }
  
  .tileCtr:hover {
    cursor: pointer;
    background: #fae4d5 !important;
  }
  
  .iconCtr {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 60px;
    height: 60px;
    border-radius: 50%;
  }
  
  .titleCtr {
    margin-top: 10px;
    font-size: 1rem;
    font-weight: bold;
    color: #f28a3e;
  }
  </style>
  
